import { createAction, props } from '@ngrx/store';

const supplierIsCreated = 'SUPPLIER_IS_CREATED';
const removeRecentSupplier = 'REMOVE_RECENT_SUPPLIER';
export const supplierIsCreatedAction = createAction(
  supplierIsCreated,
  props<{ newSupplier: any }>()
);

export const removeRecentSupplierAction = createAction(removeRecentSupplier);
